import { render, staticRenderFns } from "./CandidatesExamsStats.vue?vue&type=template&id=615f78a6&scoped=true&lang=pug&"
import script from "./CandidatesExamsStats.vue?vue&type=script&lang=js&"
export * from "./CandidatesExamsStats.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesExamsStats.vue?vue&type=style&index=0&id=615f78a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f78a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
